// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ScopeSchema } from '../inputTypeSchemas/ScopeSchema'

/////////////////////////////////////////
// EXTERNAL NETWORK CLOUD ACCOUNT POLICY SCHEMA
/////////////////////////////////////////

export const ExternalNetworkCloudAccountPolicySchema = z.object({
  autoScope: ScopeSchema,
  id: z.string(),
  tenantId: z.string(),
  surfaceId: z.string(),
  accountId: z.string(),
  enabled: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ExternalNetworkCloudAccountPolicy = z.infer<typeof ExternalNetworkCloudAccountPolicySchema>

export default ExternalNetworkCloudAccountPolicySchema;
